import React, { memo } from 'react'
import randomColor from 'randomcolor'

import { hex } from 'utils/hex'
import { equal } from 'utils/memoEqual'

const FacilityItem = ({ data, index }) => {
  const _color = randomColor({
    luminosity: 'dark',
    seed: data.name,
  })

  return (
    <div className="facility_item">
      <div
        style={{ backgroundColor: hex(_color, 10), color: _color }}
        className="facility_item_index"
      >
        {index + 1}
      </div>
      <div className="facility_item_addr">
        <span className="facility_item_addr_text">Facility №{index + 1}</span>
        <span className="facility_item_addr_text addr">{data.name}</span>
      </div>
    </div>
  )
}

export default memo(FacilityItem, equal)
